import React, { useEffect, useState } from 'react'
import "./page.css";
import BadgeIcon from '../assets/badge.png'
import { BsCalendarDateFill } from "react-icons/bs";
import { FaUser } from "react-icons/fa";
import banner_img from "../assets/search-icon.png"
import { IoLocationSharp } from "react-icons/io5";
import RoomService from "../assets/bed_image.png"
import Airconditioner from "../assets/Airconditioner.png"
import Swimming_Pool from "../assets/Swimming_Pool.png"
import Breakfast from "../assets/Breakfast.png"
import Laundry from "../assets/Laundry.png"
import Parking_Space from "../assets/Parking_Space.png"
import Pickup_Drop from "../assets/Pickup-&-Drop.png"
import Free_Wifi from "../assets/Free-Wifi.png"
import Slider_img_1 from "../assets/slider_img_1.jpg"
import Slider_img_2 from "../assets/slider_img_2.jpg"
import Slider_img_3 from "../assets/slider_img_3.jpg"
import Slider_img_4 from "../assets/slider_img_4.jpg"
import Slider_img_5 from "../assets/slider_img_5.jpg"
import Slider_img_6 from "../assets/slider_img_6.jpg"
import { RxCross1 } from "react-icons/rx";
import { BookingHoteDetailAndImagesAPI, GetProfileDetailAPI, GetUserWalletAPI } from '../Service/API/Get.js';
import { purchaseBookingAPI } from '../Service/API/Post.js';
import { ToastContainer, toast } from 'react-toastify';


export default function Booking() {
  const [selectedCard, setSelectedCard] = useState(false);
  const [hotelDetails, setHotelDetails] = useState([]);
  const [userProfileData, setUserProfileData] = useState({});
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [userWalletData, setUserWalletData] = useState({})
  const [selectedOption, setSelectedOption] = useState("default-1")
  const [isBookingDetail, setIsBookingDetail] = useState(false);

  const openPopup = (hotel) => {
    setSelectedHotel(hotel);
    setSelectedCard(true);
  };

  useEffect(() => {
    // window.location.reload();
  }, [])

  const closePopup = () => {
    setSelectedCard(null);
    setSelectedHotel(null);
  };

  const closeBookingPopup = () => {
    setIsBookingDetail(false)
  };

  const handleBookinPopup = () => {
    setIsBookingDetail(true)
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const hotelResponse = await BookingHoteDetailAndImagesAPI();
        if (hotelResponse?.data) {
          setHotelDetails(hotelResponse.data.result.data);
        }
        const profileResponse = await GetProfileDetailAPI();
        if (profileResponse?.data) {
          setUserProfileData(profileResponse.data.result.data);
        }
        const userWalletResponse = await GetUserWalletAPI();
        if (userWalletResponse?.data) {
          setUserWalletData(userWalletResponse.data.result.data)
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setHotelDetails([]);
        setUserProfileData({});
      }
    };
    fetchData();
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      price: selectedHotel?.price,
      premium: false,
      taskId: selectedHotel?._id,
      commissionFee: selectedHotel?.commissionFee,
      taskCount: userProfileData?.taskCount,
    };

    try {
      const response = await purchaseBookingAPI(formData);
      if (response?.status === 200) {
        console.log("Booking successfully processed!");
        toast.success("Booked successfully")
        closePopup();
        closeBookingPopup();
        // window.location.reload();
      } else {
        console.error("Failed to process booking:", response?.message);
      }
    } catch (error) {
      console.error("Error during form submission:", error);
    }
  };

  function formatAmount(amount) {
    if (amount % 1 >= 0.5) {
      return Math.ceil(amount);
    } else {
      return Math.floor(amount);
    }
  }

  const formattedTodayCommission = formatAmount(userWalletData.todayCommission);

  return (
    <div className='booking_main'>
      <div>
        <div className='detail_box_outer'>
          <div className='container'>
            <div className='detail_box_inner'>
              <div className='detailbox_content_left'>
                <h2>Room Details</h2>
                <p>Home /<span> Details page</span></p>
              </div>
              <div className='detail_box_content_right'>
                <h4>Booking Count: {userProfileData?.taskCount}</h4>
                <button onClick={() => openPopup()}><span><img src={BadgeIcon} /></span>Book Now & Earn Rewards</button>
              </div>
            </div>
            <div className='banner_slide'>
              <div className='banner_content'>
                <div className='banner_box'>
                  <IoLocationSharp />
                  <div className='banner_box_heading'>
                    <h6>Location</h6>
                    <p>Bangladesh</p>
                  </div>
                </div>

                <div className='banner_box'>
                  <BsCalendarDateFill />
                  <div className='banner_box_heading'>
                    <h6>Check In</h6>
                    <p>2 March 2025</p>
                  </div>
                </div>
                <div className='banner_box'>
                  <BsCalendarDateFill />
                  <div className='banner_box_heading'>
                    <h6>Check Out </h6>
                    <p>19 April 2025</p>
                  </div>
                </div>
                <div className='banner_box'>
                  <FaUser />
                  <div className='banner_box_heading'>
                    <h6>Rooms for</h6>
                    <p>2 Rooms, 4 Guests</p>
                  </div>
                </div>
              </div>
              <div className="banner_search">
                <img src={banner_img} />
                <h5>Search</h5>
              </div>
            </div>
          </div>
        </div>

        <div className='waiting_section'>
          <div className='container'>
            {hotelDetails?.map((hotel) => (
              <div key={hotel._id} className='inner_waiting'>
                <div className='waiting_images'>
                  <div className='left_big_image'>
                    <img src={hotel?.landScapeImage} alt="Hotel landscape" />
                  </div>
                  <div className='right_images_six'>
                    {hotel?.hotelImages.map((image, index) => (
                      <div key={index} className='image_box'>
                        <img src={image} alt={`Hotel image ${index + 1}`} />
                      </div>
                    ))}
                  </div>
                </div>
                <div className='waiting_content'>
                  <h2>{hotel?.name}</h2>
                  <p>{hotel?.description}</p>
                  <div className='button_outer' onClick={() => openPopup(hotel)}>
                    <span>Book Now</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className='amenity_section'>
          <div className='container'>
            <div className='inner_amenity'>
              <h2>Amenity</h2>
              <div className='amenity_divider'>
                <div className='service_box'>
                  <div className='service_boxes'>
                    <img src={RoomService} />
                    <p>Room Service</p>
                  </div>
                  <div className='service_boxes'>
                    <img src={Airconditioner} />
                    <p>Room Service</p>
                  </div>
                  <div className='service_boxes'>
                    <img src={Swimming_Pool} />
                    <p>Room Service</p>
                  </div>
                  <div className='service_boxes'>
                    <img src={Breakfast} />
                    <p>Room Service</p>
                  </div>
                  <div className='service_boxes'>
                    <img src={Laundry} />
                    <p>Room Service</p>
                  </div>
                  <div className='service_boxes'>
                    <img src={Parking_Space} />
                    <p>Room Service</p>
                  </div>
                  <div className='service_boxes'>
                    <img src={Pickup_Drop} />
                    <p>Room Service</p>
                  </div>
                  <div className='service_boxes'>
                    <img src={Free_Wifi} />
                    <p>Room Service</p>
                  </div>
                </div>

                <div className='wallet_box'>
                  <div className='wallet_box_top'></div>
                  <div className='wallet_box_top'>
                    <h4>The reservation information is displayed in detail for your viewing</h4>
                  </div>
                  <div className='wallet_box_middle'>
                    <div className='wallet_box_middle_left'>
                      <label>Trial Bonus</label>
                      <h5>₹ {userWalletData?.levelBonus}</h5>
                    </div>
                    <div className='wallet_box_middle_right'>
                      <label>Balance</label>
                      <h5>₹ {userWalletData?.totalBalance?.toFixed(0)}</h5>
                    </div>
                  </div>
                  <div className='wallet_box_middle wallet_box_middle_last'>
                    <div className='wallet_box_middle_left'>
                      <label>Today commission</label>
                      <h5>₹ {formattedTodayCommission}</h5>
                    </div>
                    <div className='wallet_box_middle_right'>
                      <label>Pending Amount</label>
                      <h5>₹ {userWalletData?.pendingAmount || "0"}</h5>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <section className='associates'>
          <div className='container'>
            <div className=' associates_heading'>
              <h2>Our Associations</h2>
              <p>At Best Western, we are proud to work closely with reputable associations and organisations that share our vision of world-class travel experiences.</p>
            </div>
            <div className='associates_slider'>
              <div className='associates_slider_inner'>
                <div className='associates_box'>
                  <img src={Slider_img_1} />
                </div>
                <div className='associates_box'>
                  <img src={Slider_img_2} />
                </div>
                <div className='associates_box'>
                  <img src={Slider_img_3} />
                </div>
                <div className='associates_box'>
                  <img src={Slider_img_4} />
                </div>
                <div className='associates_box'>
                  <img src={Slider_img_5} />
                </div>
                <div className='associates_box'>
                  <img src={Slider_img_6} />
                </div>

              </div>


            </div>
          </div>

        </section>
      </div>

      {selectedCard && selectedHotel && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-box" onClick={(e) => e.stopPropagation()}>
            <div className="popup-header">
              <h2>Booking Details</h2>
              <button className="close-btn" onClick={closePopup}><RxCross1 /></button>
            </div>
            <div className="popup-content">
              <div className='hotel_info'>
                <h2>{selectedHotel?.name}</h2>
              </div>
              <div className='level_modal'>
                <p>Order Number:</p><p>{selectedHotel?._id}</p>
              </div>
              <div className='level_modal'>
                <p>Booking Count:</p><p>{userProfileData?.taskCount}</p>
              </div>
              <div className='level_modal'>
                <p>Price:</p><p>₹ {selectedHotel?.price}</p>
              </div>
              <div className='level_modal'>
                <p>Commission:</p><p>₹ {selectedHotel?.commissionFee * selectedHotel?.price / 100}</p>
              </div>
              <button className="popup_submit_btn" onClick={handleBookinPopup}>Book Now</button>
            </div>
          </div>
        </div>
      )}

      {isBookingDetail && (
        <div className="popup-overlay" onClick={closeBookingPopup}>
          <div className="popup-box" onClick={(e) => e.stopPropagation()}>
            <div className="popup-header">
              <h2>Share Your Opinion</h2>
              <button className="close-btn" onClick={closeBookingPopup}><RxCross1 /></button>
            </div>
            <div className="modal-body">
              <p>Please select at least one option</p>
              <form onSubmit={handleFormSubmit}>
                <div className="form-check">
                  <input
                    name="type"
                    type="radio"
                    id="default-1"
                    className="form-check-input"
                    checked={selectedOption === "default-1"}
                    onChange={() => setSelectedOption("default-1")}
                  />
                  <label htmlFor="default-1" className="form-check-label">Clean environment, superb experience!</label>
                </div>

                <div className="form-check">
                  <input
                    name="type"
                    type="radio"
                    id="default-2"
                    className="form-check-input"
                    checked={selectedOption === "default-2"}
                    onChange={() => setSelectedOption("default-2")}
                  />
                  <label htmlFor="default-2" className="form-check-label">Warm hearth service during the journey!</label>
                </div>

                <div className="form-check">
                  <input
                    name="type"
                    type="radio"
                    id="default-3"
                    className="form-check-input"
                    checked={selectedOption === "default-3"}
                    onChange={() => setSelectedOption("default-3")}
                  />
                  <label htmlFor="default-3" className="form-check-label">Great and safe place all the way!</label>
                </div>

                <div className="form-check">
                  <input
                    name="type"
                    type="radio"
                    id="default-4"
                    className="form-check-input"
                    checked={selectedOption === "default-4"}
                    onChange={() => setSelectedOption("default-4")}
                  />
                  <label htmlFor="default-4" className="form-check-label">Excellent service of the staff; Friendly, Attentive, helpful</label>
                </div>

                <div className="form-check">
                  <input
                    name="type"
                    type="radio"
                    id="default-5"
                    className="form-check-input"
                    checked={selectedOption === "default-5"}
                    onChange={() => setSelectedOption("default-5")}
                  />
                  <label htmlFor="default-5" className="form-check-label">The location is convenient for everyone, easy to access and reach</label>
                </div>

                <div className="form-check">
                  <input
                    name="type"
                    type="radio"
                    id="default-6"
                    className="form-check-input"
                    checked={selectedOption === "default-6"}
                    onChange={() => setSelectedOption("default-6")}
                  />
                  <label htmlFor="default-6" className="form-check-label">Reasonable, Affordable, and cheap</label>
                </div>

                <div className="form-check">
                  <input
                    name="type"
                    type="radio"
                    id="default-7"
                    className="form-check-input"
                    checked={selectedOption === "default-7"}
                    onChange={() => setSelectedOption("default-7")}
                  />
                  <label htmlFor="default-7" className="form-check-label">Spacious, comfortable, and peaceful modern rooms</label>
                </div>

                <div className="modal_grp_btn">
                  <button type="submit" className="primary_btn">Submit Order</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />

    </div >
  );
}
